module.exports = __webpack_public_path__ + "static/media/react-logo.eb6be414.png";